import { defineKey as T } from '@ha/intl';

export const languages = {
  ar: T('Arabic'),
  bn: T('Bengali'),
  da: T('Danish'),
  nl: T('Dutch'),
  en: T('English'),
  fi: T('Finnish'),
  fr: T('French'),
  de: T('German'),
  el: T('Greek'),
  hi: T('Hindi'),
  it: T('Italian'),
  ja: T('Japanese'),
  ko: T('Korean'),
  cmn: T('Mandarin'),
  pt: T('Portuguese'),
  pl: T('Polish'),
  ru: T('Russian'),
  es: T('Spanish'),
  sv: T('Swedish'),
  tr: T('Turkish'),
  is: T('language_EditProfile.Icelandic'),
  ua: T('Ukrainian'),
};
